<template>
  <v-container class="h-auto pa-4" fluid>
    <v-row justify="center" class="h-100">
      <v-sheet class="bg-background flex-1-1 px-4">
        <div class="text-h5 text-center mb-8 font-weight-medium">My Account</div>
      </v-sheet>
    </v-row>
    <v-row justify="center" class="h-100">
      <v-sheet class="bg-background flex-1-1 pa-4" max-width="600">
        <UserAvatarEditComponent
          :user="user"
          :is-admin="authStore.isAdmin"
          @snack="throwSnack"></UserAvatarEditComponent>

        <UserEditComponent :user="user" :is-admin="authStore.isAdmin" @snack="throwSnack">
        </UserEditComponent>
        <div class="py-4">
          <div class="d-flex justify-center align-center">
            <a
              class="text-decoration-none text-primary text-body-2 font-weight-medium"
              @click="openResetPasswordModal">
              Change Password
            </a>
          </div>
        </div>
      </v-sheet>
    </v-row>

    <!-- Reset Password Modal -->
    <v-dialog v-model="showResetPasswordModal" width="600px">
      <UserPasswordResetComponent
        :user="user"
        :is-admin="authStore.isAdmin"
        :allow-close="true"
        @password-reset-canceled="showResetPasswordModal = false"
        @password-reset-completed="showResetPasswordModal = false">
      </UserPasswordResetComponent>
    </v-dialog>
    <v-dialog v-model="notUptoDateDialog" width="500">
      <v-card>
        <v-card-title class="text-h5">Update Required</v-card-title>
        <v-card-text>
          Your account information is not up to date. Please update your details to continue using
          the application.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="notUptoDateDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup lang="ts">
import { ref, defineEmits, computed, watch } from 'vue';
import { useAuthStore } from '@/stores';
import UserEditComponent from '@/components/user/UserEditComponent.vue';
import UserPasswordResetComponent from '@/components/user/UserPasswordResetComponent.vue';
import UserAvatarEditComponent from '@/components/user/UserAvatarEditComponent.vue';
import { SNACKSTATUS } from '@/stores/util';
import { useSnack } from '@/helpers';
import { UserDTO } from '@/dtos';
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
// Reactive references
const authStore = useAuthStore();
const user = computed(() => authStore.me ?? new UserDTO());
const showResetPasswordModal = ref(false);
const notUptoDateDialog = ref(false);

watch(
  () => authStore.me,
  () => {
    if (authStore.me && authStore.me.notUpToDate) {
      notUptoDateDialog.value = true;
    }
  },
  { immediate: true },
);

// Modal handlers
const openResetPasswordModal = () => {
  showResetPasswordModal.value = true;
};
</script>
